import { render, staticRenderFns } from "./BeefreeEmailEditor.vue?vue&type=template&id=2983c9fa&scoped=true"
import script from "./BeefreeEmailEditor.vue?vue&type=script&lang=js"
export * from "./BeefreeEmailEditor.vue?vue&type=script&lang=js"
import style0 from "./BeefreeEmailEditor.vue?vue&type=style&index=0&id=2983c9fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2983c9fa",
  null
  
)

export default component.exports